/* Startseite „Der Kreis“, Fassung 3 (03.10.2026). Ohne dieses Skript ist alles da; es fügt nur Bewegung mit Zweck und
   die Live-Zeilen hinzu:
   1 Öffnungsstatus (aus settings.cm_hours, Uhrzeit Europe/Berlin) oben und im Schluss
   2 Tagesplan: Zeitfenster, Stundenraster, „Jetzt“-Punkt (gleitet einmal an seinen Platz), Same-Day-Zeile
   3 Kreis: Lichtpunkt reist von Station zu Station, darunter steht die Station; Zeiger/Fokus/Antippen hält an
   4 Flotte: Regler 1–50; kommt sie ins Bild, zieht sie sich EINMAL selbst von 1 auf 12 (1,8 s) und bleibt stehen
   5 Tasten tippen einmal
   Keine Einblend-Animationen, kein Hochzählen. „Bewegung reduzieren“: keine Reise, keine Selbstbewegung, kein Tippen,
   kein Gleiten. Keine Anfragen ans Netz. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cmx-h]');
  if (!root) return;
  var doc = document.documentElement;
  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var T = {};
  try { T = JSON.parse((root.querySelector('[data-cmx-h-texts]') || {}).textContent || '{}'); } catch (e) { T = {}; }
  var DROP = 12 * 60, PICK = 16 * 60 + 30; // „bis 12 Uhr bringen, ab 16:30 Uhr abholen“ (cm_repair.home.lead)

  /* ── Zeit in Friedrichshafen ── */
  function berlinNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      var wd = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 }[o.weekday];
      return { day: wd, min: (+o.hour % 24) * 60 + (+o.minute) };
    } catch (e) { var d = new Date(); return { day: (d.getDay() + 6) % 7, min: d.getHours() * 60 + d.getMinutes() }; }
  }
  /* „Mo–Fr 09–18 Uhr · Sa 10–14 Uhr“ → [[540,1080],…,[600,840],null]; null, wenn das Muster nicht passt */
  function parseHours(src) {
    var codes = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
    var week = [null, null, null, null, null, null, null];
    if (!src) return null;
    var segs = src.replace(/-/g, '–').split('·');
    for (var s = 0; s < segs.length; s++) {
      var m = /^\s*([A-Za-z]{2})(?:–([A-Za-z]{2}))?\s+(\d{1,2})(?:[:.](\d{2}))?–(\d{1,2})(?:[:.](\d{2}))?/.exec(segs[s]);
      if (!m) return null;
      var a = codes.indexOf(m[1]), b = m[2] ? codes.indexOf(m[2]) : a;
      var from = (+m[3]) * 60 + (+(m[4] || 0)), to = (+m[5]) * 60 + (+(m[6] || 0));
      if (a < 0 || b < a || to <= from || to > 1440) return null;
      for (var d = a; d <= b; d++) week[d] = [from, to];
    }
    return week.some(Boolean) ? week : null;
  }
  var week = parseHours(root.getAttribute('data-hours'));
  var fmt = function (min) { var h = Math.floor(min / 60), m = min % 60; return (doc.lang === 'en' ? h : (h < 10 ? '0' + h : h)) + ':' + (m < 10 ? '0' : '') + m; };
  var fmtShort = function (min) { var h = Math.floor(min / 60), m = min % 60; return m ? fmt(min) : String(h); };
  var dayWord = function (offset, day) {
    if (offset === 0) return T.today || '';
    if (offset === 1) return T.tomorrow || '';
    var names = (T.days || '').split('|'); // So|Mo|…
    return names[(day + 1) % 7] || '';
  };
  function nextOpen(now) {
    for (var k = 0; k < 8; k++) {
      var d = (now.day + k) % 7, h = week[d];
      if (!h) continue;
      if (k === 0 && now.min >= h[0]) continue;
      return { offset: k, day: d, at: h[0] };
    }
    return null;
  }
  function nextSameDay(now) {
    for (var k = 0; k < 8; k++) {
      var d = (now.day + k) % 7, h = week[d];
      if (!h || h[0] >= DROP || h[1] < PICK) continue;
      if (k === 0 && now.min >= DROP) continue;
      return { offset: k, day: d };
    }
    return null;
  }

  /* ── 1 Öffnungsstatus ── */
  function liveStatus() {
    if (!week || !T.open) return;
    var now = berlinNow(), h = week[now.day], txt, open = false;
    if (h && now.min >= h[0] && now.min < h[1]) { open = true; txt = T.open.replace('%t', fmtShort(h[1])); }
    else { var n = nextOpen(now); if (!n) return; txt = T.closed.replace('%d', dayWord(n.offset, n.day)).replace('%t', fmtShort(n.at)); }
    var live = root.querySelector('[data-cmx-h-live]');
    if (live) { live.classList.add('is-live'); live.setAttribute('data-open', open ? '1' : '0'); var t = live.querySelector('[data-cmx-h-live-text]'); if (t) t.textContent = txt; }
    var copy = root.querySelector('[data-cmx-h-live-copy]'); if (copy) copy.textContent = txt;
  }

  /* ── 2 Tagesplan ── */
  var sunWait = false, sunGo = null; // „Jetzt“ wartet links, bis der Plan im Bild ist, und gleitet dann einmal an seinen Platz
  function sunWatch() {
    var box = root.querySelector('[data-cmx-h-day]'), sun = box && box.querySelector('[data-cmx-h-sun]');
    if (!sun || motion.matches || !('IntersectionObserver' in window)) return;
    sunWait = true;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; io.disconnect(); sunWait = false;
      if (sunGo != null) setTimeout(function () { sun.style.setProperty('--at', sunGo); }, 250);
    }, { threshold: .5 });
    io.observe(box);
  }
  /* Beschriftung eines Zeitfensters, die nicht hineinpasst, ausblenden statt abschneiden (die Zeiten stehen darunter) */
  function tight(box) {
    Array.prototype.forEach.call(box.querySelectorAll('.cmx-h-band'), function (b) {
      b.classList.remove('is-tight'); var t = b.querySelector('b');
      if (t && !b.hidden && t.scrollWidth > b.clientWidth - 12) b.classList.add('is-tight');
    });
  }
  var tightT = null;
  window.addEventListener('resize', function () { clearTimeout(tightT); tightT = setTimeout(function () { var box = root.querySelector('[data-cmx-h-day]'); if (box) tight(box); }, 200); });
  function dayLine() {
    var box = root.querySelector('[data-cmx-h-day]'); if (!box || !week) return;
    var now = berlinNow();
    var lo = 1440, hi = 0; week.forEach(function (h) { if (h) { lo = Math.min(lo, h[0]); hi = Math.max(hi, h[1]); } });
    var r0 = Math.max(0, lo - 60), r1 = Math.min(1440, hi + 60), span = r1 - r0;
    var at = function (min) { return Math.max(0, Math.min(1, (min - r0) / span)).toFixed(4); };
    var sky = box.querySelector(".cmx-h-day-sky"); if (sky) sky.style.setProperty("--hours", (span / 60).toFixed(3));
    var h = week[now.day]; var shownDay = now.day;
    if (!h) { var n = nextOpen(now); if (n) { h = week[n.day]; shownDay = n.day; } }
    if (!h) return;
    var full = h[0] < DROP && h[1] >= PICK;
    var set = function (sel, from, to) { var el = box.querySelector(sel); if (!el) return; if (from == null) { el.hidden = true; return; } el.hidden = false; el.style.setProperty('--from', at(from)); el.style.setProperty('--to', at(to)); };
    if (full) { set('[data-cmx-h-band="drop"]', h[0], DROP); set('[data-cmx-h-band="work"]', DROP, PICK); set('[data-cmx-h-band="pick"]', PICK, h[1]); }
    else { set('[data-cmx-h-band="drop"]', h[0], h[1]); set('[data-cmx-h-band="work"]', null); set('[data-cmx-h-band="pick"]', null); }
    var pin = function (name, min, show) { var el = box.querySelector('[data-cmx-h-pin="' + name + '"]'); if (!el) return; el.hidden = !show; el.style.setProperty('--at', at(min)); var tt = el.querySelector('[data-cmx-h-pin-time]'); if (tt) tt.textContent = fmt(min); };
    pin('open', h[0], true); pin('close', h[1], true); pin('drop', DROP, full); pin('pick', PICK, full);
    tight(box);
    var sun = box.querySelector('[data-cmx-h-sun]');
    if (sun) {
      var inRange = shownDay === now.day && now.min >= r0 && now.min <= r1;
      sun.hidden = !inRange;
      if (inRange) { var pos = at(now.min); if (+pos > .74) sun.setAttribute('data-flip', ''); else sun.removeAttribute('data-flip'); if (sunWait) { sunGo = pos; sun.style.setProperty('--at', '0'); } else sun.style.setProperty('--at', pos); var st = sun.querySelector('[data-cmx-h-sun-time]'); if (st) st.textContent = fmt(now.min); if (now.min < h[0] || now.min >= h[1]) sun.setAttribute('data-night', ''); else sun.removeAttribute('data-night'); }
    }
    var status = box.querySelector('[data-cmx-h-same]');
    if (status && T.sameNow) {
      var todayOk = week[now.day] && week[now.day][0] < DROP && week[now.day][1] >= PICK;
      var txt, tone = 'next';
      if (todayOk && now.min < DROP) { var left = DROP - now.min; txt = T.sameNow.replace('%h', Math.floor(left / 60)).replace('%m', left % 60); tone = 'now'; }
      else if (todayOk && now.min < PICK) { txt = T.sameWork; }
      else { var nx = nextSameDay(now); txt = nx ? T.sameNext.replace('%d', dayWord(nx.offset, nx.day)) : ''; }
      status.textContent = txt || ''; status.setAttribute('data-tone', tone);
    }
  }

  /* ── 3 Der Kreis ── */
  function ring() {
    var orbit = root.querySelector('[data-cmx-h-orbit]'); if (!orbit) return;
    var comet = orbit.querySelector('[data-cmx-h-comet]'), trail = orbit.querySelector('[data-cmx-h-trail]');
    var cap = orbit.querySelector('[data-cmx-h-cap]'), capT = orbit.querySelector('[data-cmx-h-cap-title]'), capX = orbit.querySelector('[data-cmx-h-cap-text]'), capGo = orbit.querySelector('[data-cmx-h-cap-go]');
    var pauseBtn = orbit.querySelector('[data-cmx-h-pause]');
    var angle = 0, idx = 0, timer = null, raf = null, userPaused = false, hold = false, visible = false;
    var stops = function () { var set = orbit.querySelector('#cmx-h-mode-b') && orbit.querySelector('#cmx-h-mode-b').checked ? 'business' : 'private'; return Array.prototype.slice.call(orbit.querySelectorAll('.cmx-h-stops[data-set="' + set + '"] .cmx-h-stop')); };
    var place = function (a) { angle = a; if (comet) comet.style.setProperty('--a', a + 'deg'); if (trail) trail.style.transform = 'rotate(' + (a - 46 - 90) + 'deg)'; };
    var show = function (i, animate) {
      var list = stops(); if (!list.length) return;
      idx = (i + list.length) % list.length;
      list.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      var s = list[idx];
      if (capT) capT.textContent = s.getAttribute('data-title') || '';
      if (capX) capX.textContent = s.getAttribute('data-text') || '';
      if (capGo) capGo.setAttribute('href', s.getAttribute('href'));
      if (cap && animate !== false && !motion.matches) { cap.classList.remove('is-swap'); void cap.offsetWidth; cap.classList.add('is-swap'); }
      var target = idx * 360 / list.length;
      if (motion.matches || animate === false) { place(target); return; }
      var from = angle % 360; if (from < 0) from += 360; var to = target; if (to < from - 0.5) to += 360;
      if (Math.abs(to - from) > 200) to = from + ((to - from) - 360);
      var t0 = null, dur = 900; if (raf) cancelAnimationFrame(raf);
      var step = function (ts) { if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; place(from + (to - from) * e); if (p < 1) raf = requestAnimationFrame(step); else place(target); };
      raf = requestAnimationFrame(step);
    };
    var running = function () { return !userPaused && !hold && visible && !motion.matches && !document.hidden; };
    /* Versuch 04.10.2026 (Änderung 8, Vorbild linear.app: EIN orchestrierter Moment statt Dauerbewegung): steht in
       assets/cm-x-home.css an .cmx-h-orbit die Variable --cmx-h-runden (z. B. 1), reist der Lichtpunkt so viele Runden
       und hält dann bei „Beraten“; der Knopf zeigt „Abspielen“. Wer abspielt, bekommt die Dauerreise. Ohne Variable
       (CSS-Block VERSUCH-8 gelöscht) läuft der Ring wie bisher endlos. */
    var rounds = parseFloat(getComputedStyle(orbit).getPropertyValue('--cmx-h-runden')) || 0, autoSteps = 0;
    var tick = function () { clearTimeout(timer); timer = setTimeout(function () { if (running()) { show(idx + 1); autoSteps++; if (rounds > 0 && autoSteps >= rounds * stops().length) { setPaused(true); return; } } tick(); }, 3000); };
    var setPaused = function (p) { userPaused = p; if (!pauseBtn) return; pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false'); var l = pauseBtn.querySelector('[data-cmx-h-pause-label]'); if (l) l.textContent = p ? (T.play || '') : (T.pause || ''); };
    orbit.addEventListener('pointerover', function (e) { var s = e.target.closest && e.target.closest('.cmx-h-stop'); if (s) { hold = true; var list = stops(); var k = list.indexOf(s); if (k >= 0 && k !== idx) show(k); } });
    orbit.addEventListener('pointerleave', function () { hold = false; });
    orbit.addEventListener('focusin', function (e) { var s = e.target.closest && e.target.closest('.cmx-h-stop'); if (s) { hold = true; var k = stops().indexOf(s); if (k >= 0) show(k); } });
    orbit.addEventListener('focusout', function () { hold = false; });
    orbit.addEventListener('change', function (e) { if (e.target && e.target.name === 'cmx-h-mode') { idx = 0; show(0); } });
    if (pauseBtn) { pauseBtn.hidden = motion.matches; pauseBtn.addEventListener('click', function () { setPaused(!userPaused); if (!userPaused) { rounds = 0; tick(); } }); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: .25 }).observe(orbit); else visible = true;
    show(0, false); tick();
  }

  /* ── 4 Flotte ──
     Ohne Skript und bei „Bewegung reduzieren“ steht sie auf dem Wert aus dem Liquid (12). Mit Skript wartet sie auf 1;
     sobald sie zur Hälfte im Bild ist, zieht sie den Regler EINMAL selbst bis 12 (1,8 s, sanft an- und auslaufend)
     und bleibt stehen. Wer vorher oder währenddessen zieht, tippt oder eine Taste drückt, übernimmt sofort. */
  function fleet() {
    var box = root.querySelector('[data-cmx-h-fleet]'); if (!box) return;
    var range = box.querySelector('[data-cmx-h-fleet-range]'), out = box.querySelector('[data-cmx-h-fleet-out]');
    if (!range) return;
    var units = Array.prototype.slice.call(box.querySelectorAll('.cmx-h-unit'));
    /* 04.10.2026 Inhaber: bis 50 Schritt für Schritt, danach Stufen 100, 200, 500, 1000+. Die Stufen hängen als eigene
       Reglerpositionen hinter der 50 (data-stages); jede Stufe legt eine Lage mehr hinter die Symbole (data-stack). */
    var stages = String(range.getAttribute('data-stages') || '').split(',').map(Number).filter(function (x) { return x > 0; });
    var cells = units.length || 50;
    var lo = +range.min || 1, hi = +range.max || cells + stages.length, goal = +range.value || 12, from = lo, shown = -1;
    var num = function (x) { try { return x.toLocaleString(doc.lang === 'en' ? 'en-GB' : 'de-DE'); } catch (e) { return String(x); } };
    var set = function (v) {
      var n = Math.max(lo, Math.min(hi, Math.round(v)));
      if (n !== shown) {
        shown = n;
        var st = n > cells ? n - cells : 0, count = st ? stages[st - 1] : n;
        var label = n === 1 ? (T.fleetOne || '1') : (T.fleetMany || '%n').replace('%n', num(count) + (st && st === stages.length ? '+' : ''));
        units.forEach(function (u, k) { u.classList.toggle('is-on', k < n); });
        box.setAttribute('data-stack', String(st)); box.classList.toggle('is-stage', st > 0);
        if (out) out.textContent = label;
        range.setAttribute('aria-valuetext', label);
      }
      range.style.setProperty('--p', ((v - lo) / (hi - lo) * 100).toFixed(2) + '%');
    };
    var raf = null, auto = false, done = false;
    var finish = function (v) { if (raf) cancelAnimationFrame(raf); raf = null; auto = false; done = true; range.step = '1'; range.value = String(v); set(v); box.classList.remove('is-auto'); };
    var takeOver = function () { done = true; if (auto) finish(shown); };
    range.addEventListener('input', function () { if (auto) finish(Math.round(+range.value)); done = true; set(+range.value); });
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (t) { range.addEventListener(t, takeOver, { passive: true }); });
    set(goal);
    if (motion.matches || !('IntersectionObserver' in window)) return;
    range.value = String(from); set(from);
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; io.disconnect();
      setTimeout(function () {
        if (done) return;
        auto = true; box.classList.add('is-auto'); range.step = 'any';
        var t0 = null, dur = 1800;
        var step = function (ts) {
          if (!auto) return;
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          var v = from + (goal - from) * e; range.value = String(v); set(v);
          if (p < 1) raf = requestAnimationFrame(step); else finish(goal);
        };
        raf = requestAnimationFrame(step);
      }, 300);
    }, { threshold: .5 });
    io.observe(box);
  }

  /* ── 5 Tasten ── */
  function board() {
    var b = root.querySelector('[data-cmx-h-board]'); if (!b || motion.matches || !('IntersectionObserver' in window)) return;
    var keys = Array.prototype.slice.call(b.querySelectorAll('.cmx-h-key'));
    var io = new IntersectionObserver(function (en) { if (!en[0].isIntersecting) return; io.disconnect(); keys.forEach(function (k, i) { setTimeout(function () { k.classList.add('is-pressed'); setTimeout(function () { k.classList.remove('is-pressed'); }, 240); }, 300 + i * 170); }); }, { threshold: .5 });
    io.observe(b);
  }

  var safe = function (f) { try { f(); } catch (e) { /* Seite bleibt, wie sie ohne Skript ist */ } };
  safe(liveStatus); safe(sunWatch); safe(dayLine); safe(ring); safe(fleet); safe(board);
  doc.classList.add('cmx-h-ready');
  setInterval(function () { if (!document.hidden) { safe(liveStatus); safe(dayLine); } }, 60000);
})();
